// extracted by mini-css-extract-plugin
module.exports = {"college-filters-edit-form-header":"_2zgdGViI8v7q60NRC3IefX"};